import React from 'react';
import { Link } from 'react-router-dom';

type Variant = 'primary' | 'secondary' | 'ghost';
type Size = 'md' | 'lg';

export function Button({
    children,
    variant = 'primary',
    size = 'md',
    pill = false,
    block = false,
    arrow = false,
    to,
    href,
    newTab = false,
    type = 'button',
    disabled = false,
    className = '',
    ...rest
}: {
    children: React.ReactNode;
    variant?: Variant;
    size?: Size;
    pill?: boolean;
    block?: boolean;
    arrow?: boolean;
    to?: string;
    href?: string;
    newTab?: boolean;
    type?: 'button' | 'submit';
    disabled?: boolean;
    className?: string;
} & React.HTMLAttributes<HTMLElement>) {
    const cls = [
        'ds-btn',
        `ds-btn--${variant}`,
        `ds-btn--${size}`,
        pill ? 'ds-btn--pill' : '',
        disabled ? 'ds-btn--disabled' : '',
        block ? 'ds-btn--block' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    const inner = (
        <>
            {children}
            {arrow && (
                <svg className="ds-btn__arrow" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M3 8h9M8.5 4.5 12 8l-3.5 3.5" />
                </svg>
            )}
        </>
    );

    if (to) {
        return (
            <Link to={to} className={cls} {...rest}>
                {inner}
            </Link>
        );
    }
    if (href) {
        return (
            <a
                href={href}
                className={cls}
                target={newTab ? '_blank' : undefined}
                rel={newTab ? 'noreferrer' : undefined}
                {...rest}
            >
                {inner}
            </a>
        );
    }
    return (
        <button type={type} disabled={disabled} className={cls} {...(rest as React.ButtonHTMLAttributes<HTMLButtonElement>)}>
            {inner}
        </button>
    );
}
